import { useTranslation } from '../../../utils/useTranslation';
import { Box } from '../../layout/Box';
import { Price } from '../../price/Price';
import { formatBalance } from './utils/formatBalance';
import type { CpaPromoBalanceProps } from './types';

export const CpaPromoBalance: React.FC<CpaPromoBalanceProps> = ({ balance, isShort, ...other }) => {
    const t = useTranslation();

    const labelText = {
        thousand: t('тыс.'),
        millions: t('млн.'),
    };

    return (
        <Box {...other}>
            <Price
                px={0.75}
                py={0.25}
                borderRadius="100px"
                background="var(--accent)"
                variant="caption2"
                color="invert"
                priceInfo={{
                    currency: 'RUB',
                    integerPart: balance,
                    formatted: isShort ? formatBalance(balance, labelText) : undefined,
                }}
            />
        </Box>
    );
};
